<template>
  <div class="page-config">
    <el-row>
      <div class="model-container">
        <div class="model-content">
          <el-form ref="form">
            <component
              :is="`tms-type-${item.type}`"
              source="tmsPageConfig"
              :field="item"
              v-for="(item, index) in fields"
              :key="index"
              :config="config"
            >
            </component>
          </el-form>
        </div>
      </div>
    </el-row>
  </div>
</template>



<script>
export default {
  name: "tms-page-config",
  // props: {
  //   // fields: {
  //   //   type: [Object, Array],
  //   //   required: true
  //   // },
  //   // config: {
  //   //   type: Object,
  //   //   default() {
  //   //     return {}
  //   //   }
  //   // }
  // },
  computed: {
    // 常规组件的数据初始化值
    config() {
      return this.$store.state.tms.pageData;
    },
    // 需要渲染的常规组件
    fields() {
      return this.$store.state.tms.ruleComponentList;
    },
  },
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {},
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>